import { render, staticRenderFns } from "./areaCode.vue?vue&type=template&id=2222f413&scoped=true"
import script from "./areaCode.vue?vue&type=script&lang=js"
export * from "./areaCode.vue?vue&type=script&lang=js"
import style0 from "./areaCode.vue?vue&type=style&index=0&id=2222f413&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2222f413",
  null
  
)

export default component.exports